import { render, staticRenderFns } from "./Removed.vue?vue&type=template&id=4bb31971&scoped=true&"
import script from "./Removed.vue?vue&type=script&lang=js&"
export * from "./Removed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bb31971",
  null
  
)

export default component.exports